import React from 'react';
import { View } from 'react-native';
import { luxColors } from "../../../theming/themes/legacy/colors";
import util from '../../util';
export var StatusType;
(function (StatusType) {
    StatusType["success"] = "success";
    StatusType["warning"] = "warning";
    StatusType["error"] = "error";
    StatusType["info"] = "info";
    StatusType["tag"] = "tag";
    StatusType["primary"] = "primary";
})(StatusType || (StatusType = {}));
const S = {
    Circle: (status) => ({
        height: 8,
        width: 8,
        borderRadius: 8 / 2,
        backgroundColor: luxColors[status].primary,
        marginTop: 1,
    }),
};
const StatusBullet = (props) => {
    const { status } = props;
    return (<View style={util.mergeStyles(undefined, S.Circle(status), [{ borderWidth: 3, height: 12, width: 12, borderRadius: 12 / 2 }, (props.mode === 'grid')])}/>);
};
export default StatusBullet;
//# sourceMappingURL=StatusBullet.js.map